import { render, staticRenderFns } from "./EnterPassword.vue?vue&type=template&id=13bfdf57&"
import script from "./EnterPassword.vue?vue&type=script&lang=js&"
export * from "./EnterPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports